import React from 'react';
import { Accordion } from 'react-bootstrap';
import CertificateItem from './CertificateItem';

const Signatures = ({ history }) => {
    return (
        <Accordion>
            <CertificateItem key={0} certificate={history.certificado} index={1} />
            {
                history.firmas.map((signature, index) => (
                    <CertificateItem key={`sci${index + 1}`} certificate={signature.certificado} index={index+2} />
                ))
            }
        </Accordion>
    );
};

export default Signatures;